import { SNP_UNTESTED_COLOR } from "@/utils/getSnpColor";

export default function getGenePalette(geneConfig) {
    const lozengeFill =
      geneConfig?.lozengeColor ?? geneConfig?.lozenge ?? geneConfig?.color ?? SNP_UNTESTED_COLOR;
    const snpArray = Array.isArray(geneConfig?.snpColor) ? geneConfig.snpColor : [];
  
    return {
      lozengeFill,
      getSnpFill(index) {
        if (snpArray.length === 0) {
          return SNP_UNTESTED_COLOR;
        }

        return snpArray[index] ?? SNP_UNTESTED_COLOR;
      },
      getSnpSymbol(index) {
        return geneConfig?.symbol?.[index] ?? 'circle';
      }
    };
  }